import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Separador de dia da conversa ("Hoje", "Ontem", "12 de setembro de 2026"),
 * COMPARTILHADO pelos 4 inboxes (paridade B3 da matriz de canais, fechada em
 * 2026-09-17). Antes existia so no WhatsApp QR e no Business, copiado nos dois;
 * no Instagram e no Messenger a conversa virava um fluxo continuo sem marca de
 * dia nenhuma.
 *
 * O que e CORE aqui: o rotulo e a aparencia. O que e do CANAL: de qual campo
 * sai o instante da mensagem (o QR guarda epoch em segundos em
 * `messageTimestamp`, o Business tem `timestamp`/`created_at` em ISO, o
 * Instagram e o Messenger tem `timestamp`). Por isso o agrupador recebe uma
 * funcao que sabe ler o instante, em vez de adivinhar o campo.
 */

/**
 * Epoch em SEGUNDOS a partir de Date, ISO, epoch em ms, epoch em s, string
 * numerica ou "2026-01-24 12:00:00" (sem o T, que alguns navegadores recusam).
 * Reune as estrategias que o wa-business ja tinha no parseTimestamp e a
 * conversao de segundos que o wa-personal fazia na mao. 0 quando nao da.
 */
export function toEpochSeconds(valor) {
  if (valor === null || valor === undefined || valor === '') return 0;
  if (valor instanceof Date) {
    const t = valor.getTime();
    return Number.isNaN(t) ? 0 : Math.floor(t / 1000);
  }
  if (typeof valor === 'number') {
    if (Number.isNaN(valor)) return 0;
    // numero cru menor que 10^10 e epoch em SEGUNDOS: new Date(1757...) leria
    // como milissegundos e cairia em 1970.
    return Math.floor(valor < 10000000000 ? valor : valor / 1000);
  }
  const texto = String(valor);
  let ms = new Date(texto).getTime();
  if (!Number.isNaN(ms)) return Math.floor(ms / 1000);
  const n = Number(texto);
  if (!Number.isNaN(n)) {
    ms = n < 10000000000 ? n * 1000 : n;
    if (!Number.isNaN(ms)) return Math.floor(ms / 1000);
  }
  ms = new Date(texto.replace(' ', 'T')).getTime();
  return Number.isNaN(ms) ? 0 : Math.floor(ms / 1000);
}

/** "Hoje" | "Ontem" | "12 de setembro de 2026". Vazio quando nao da para ler. */
export function formatDayLabel(valor) {
  const segundos = toEpochSeconds(valor);
  if (!segundos) return '';
  const data = new Date(segundos * 1000);
  if (Number.isNaN(data.getTime())) return '';
  const hoje = new Date();
  const ontem = new Date(hoje);
  ontem.setDate(ontem.getDate() - 1);
  if (data.toDateString() === hoje.toDateString()) return 'Hoje';
  if (data.toDateString() === ontem.toDateString()) return 'Ontem';
  return data.toLocaleDateString('pt-BR', {
    day: '2-digit', month: 'long', year: 'numeric',
  });
}

/**
 * Agrupa uma linha do tempo ja ordenada em [{ rotulo, itens }], preservando a
 * ordem. `getTimestamp` recebe o item e devolve o instante bruto do canal.
 * Dia que nao da para ler entra sem rotulo (rotulo vazio), e o shell nao
 * desenha separador para ele em vez de mostrar "Data desconhecida".
 */
export function groupTimelineByDay(itens, getTimestamp) {
  const grupos = [];
  (itens || []).forEach((item) => {
    const rotulo = formatDayLabel(getTimestamp(item));
    const ultimo = grupos[grupos.length - 1];
    if (ultimo && ultimo.rotulo === rotulo) ultimo.itens.push(item);
    else grupos.push({ rotulo, itens: [item] });
  });
  return grupos;
}

const ChatDateDivider = ({ label }) => {
  const { colors } = useTheme();
  if (!label) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', margin: '16px 0' }}>
      <span
        style={{
          backgroundColor: colors.bgTertiary,
          padding: '6px 14px',
          borderRadius: '8px',
          fontSize: '12px',
          color: colors.textSecondary,
          boxShadow: colors.shadowSm,
        }}
      >
        {label}
      </span>
    </div>
  );
};

export default ChatDateDivider;
